import { render, staticRenderFns } from "./EconomicCalendar.vue?vue&type=template&id=1d315b8c&scoped=true"
import script from "./EconomicCalendar.vue?vue&type=script&lang=js"
export * from "./EconomicCalendar.vue?vue&type=script&lang=js"
import style0 from "./EconomicCalendar.vue?vue&type=style&index=0&id=1d315b8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d315b8c",
  null
  
)

export default component.exports